import React from "react";
import { Routes, Route } from "react-router-dom";
import { PageNewProject, PageTableProjectClient, PageUser } from '../pages/inmersys';
import ComercialPage from "../pages/inmersys/comercial/ComercialPage";
import { General } from "../pages/inmersys/General2/General";
import { LayoutInmersys } from "../layout/LayoutInmersys";
import { InmersysRoot, PathRoot } from "./type_router";
import { AnalityRouter } from "./AnalityRouter";
import { ProjectRouter } from "./ProjectRouter";
import { GraphRouter } from "./GraphRouter";
import { CmsRouter } from "./CmsRouter";



/**
 * El enrutador global llama a
 * @constant PathRoot = Trae las rutas globales
 * @CmsRouter El cms del enrutador, para hacer cambios en estatus, o agregar nuevas categorias
 * @ProjectRouter Vista detalles de proyectos clientes, scrum.
 * @constant InmersysRoot tiene las paginas de inmersys
 */
export const InmersysRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<LayoutInmersys />}>
                <Route index element={<General />} />
                <Route path={PathRoot.cms} element={<CmsRouter />} />
                <Route path={PathRoot.anality} element={<AnalityRouter />} />
                <Route path={PathRoot.project} element={<ProjectRouter />} />
                <Route path={PathRoot.graph} element={<GraphRouter />} />
                <Route path={InmersysRoot.newProject} element={<PageNewProject />} />
                <Route path={InmersysRoot.projectinmersys} element={<PageTableProjectClient />} />
                <Route path={InmersysRoot.user} element={<PageUser />} />
                <Route path={InmersysRoot.buscador} element={<ComercialPage />} />
            </Route>
        </Routes>
    );
};

